import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// Axios interceptor for handling 401 errors
axios.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401 && store.state.auth.isAuthenticated) {
      try {
        await store.dispatch('auth/refreshToken');
        // Retry the original request
        return axios(error.config);
      } catch (refreshError) {
        store.dispatch('auth/logout');
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
